import { useState } from "react"

export const Variable =() => {
    const [state, setState] = useState({
        name: '',
        open: false,
        openPermission: false,
        arr1: [],
        Load: false,
        role_id: ""
    })
    const setStateCustom = (variableName, value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenPermission = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openPermission: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenPermission,
    setStateCustom,
    setLoad
  }
}
